






































































































import { Vue, Component, Mixins,Prop } from "vue-property-decorator";
import MyList from "@/mixins/list";
import moment from "moment";
import MyConfig from "@/config.ts";

@Component
export default class extends Mixins(MyList) {
  @Prop() invest!: any;

  dispatchType = "investigate/list";

  columns: any[] = [
    { title: "姓名", dataIndex: "username" },
    { title: "手机号", dataIndex: "mobile" },
    { title: "问卷标题", dataIndex: "title" },
    { title: "题型", scopedSlots: {customRender:"mode"} },
    { title: this.invest.mode<2?"总得分":"总次数", scopedSlots: { customRender: "score" } },
    { title: "总用时", scopedSlots: { customRender: "times" } },
    { title: "时间", scopedSlots: { customRender: "time" } },
    { title: "操作", scopedSlots: { customRender: "action" } },
  ];

  mounted() {
    // this.searchData={id:this.invest.id}
    this.loadData({
      id:this.invest.id,
      pageSize: 10,
    },false);
  }

  getDetail(data:any){
    return MyConfig.casapi+'/investigate/detail?id='+data.id;
  }

  getTime(data:any){
    return moment(data.created_time).format('YYYY-MM-DD HH:mm')
  }

  getScore(data:any){
    return data.score + (data.total?(' / ' + data.total):'')
  }

}
